module.exports = __webpack_public_path__ + "img/SES_235425010.a6c83681.jpg";